import { render, staticRenderFns } from "./LeftView.vue?vue&type=template&id=007f07c5"
import script from "./LeftView.vue?vue&type=script&lang=js"
export * from "./LeftView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports